import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PS } from '../theme';
import { Avatar, Wordmark } from '../lib/ui';
import { Icon } from '../lib/icons';
import api from '../lib/api';
import { notifyError } from '../lib/toast';

/** Internal QA login — sign in as one of 15 fixed test accounts (no Google).
 *  Only works when the backend has DEV_LOGIN_ENABLED=true (preview/QA). */
export default function DevLogin() {
  const nav = useNavigate();
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(null);

  useEffect(() => {
    api.get('/auth/dev-login/status').then((r) => setStatus(r.data)).catch(() => setStatus({ enabled: false, accounts: [] }));
  }, []);

  const loginAs = async (id) => {
    setBusy(id);
    try {
      await api.post('/auth/dev-login', { test_id: id });
      // Full reload (NOT SPA nav) so AuthProvider re-validates the session and ALL
      // user-scoped data refetches for the new account — prevents the previous
      // tester's profile / credit / notifications from lingering (privacy).
      window.location.href = '/app';
    } catch (e) {
      notifyError(e?.response?.data?.detail || 'เข้าสู่ระบบไม่สำเร็จ');
      setBusy(null);
    }
  };

  return (
    <div style={{ minHeight: '100dvh', background: PS.page, color: PS.text, fontFamily: PS.fontUI, padding: '24px 16px 48px', maxWidth: 560, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 20 }}>
        <Wordmark size={20} />
        <span style={{ fontSize: 11, fontWeight: 700, color: '#fff', background: 'oklch(0.64 0.16 48)', padding: '3px 9px', borderRadius: 999, letterSpacing: 0.5 }}>QA · TEST LOGIN</span>
      </div>
      <h1 style={{ fontSize: 20, fontWeight: 700, margin: '0 0 4px' }}>เข้าสู่ระบบสำหรับทดสอบ</h1>
      <p style={{ fontSize: 12.5, color: PS.textMuted, margin: '0 0 18px', lineHeight: 1.5 }}>เลือกบัญชีทดสอบเพื่อเข้าใช้งานทันที (ไม่ผ่าน Google) — สำหรับ QA ใน preview เท่านั้น</p>

      {status && !status.enabled && (
        <div data-testid="dev-login-disabled" style={{ padding: 18, borderRadius: 14, background: PS.surface, border: `1px solid ${PS.line}`, fontSize: 13, color: PS.danger, lineHeight: 1.6 }}>
          ระบบ login ทดสอบถูกปิดอยู่บนเซิร์ฟเวอร์นี้ (DEV_LOGIN_ENABLED ไม่ได้เปิด) — ใช้ได้เฉพาะ preview/QA
        </div>
      )}

      {status?.enabled && (
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {status.accounts.map((a) => (
            <button key={a.id} data-testid={`dev-login-${a.id}`} onClick={() => loginAs(a.id)} disabled={busy !== null} className="ps-press"
              style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 12px', borderRadius: 14, background: PS.surface2, border: `1px solid ${PS.line}`, cursor: 'pointer', textAlign: 'left', opacity: busy !== null && busy !== a.id ? 0.5 : 1 }}>
              <Avatar name={a.name} size={38} />
              <div style={{ minWidth: 0, flex: 1 }}>
                <div style={{ fontSize: 10, color: PS.textMuted }}>ID #{a.id}</div>
                <div style={{ fontSize: 13, fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{busy === a.id ? 'กำลังเข้า…' : a.name}</div>
              </div>
              <Icon.chevronR size={16} stroke={PS.textDim} />
            </button>
          ))}
        </div>
      )}

      <button data-testid="dev-login-home" onClick={() => nav('/app')} style={{ marginTop: 20, background: 'transparent', border: 'none', color: PS.textMuted, fontSize: 13, fontFamily: PS.fontUI, cursor: 'pointer' }}>
        ← กลับหน้าแอป (โหมดผู้เยี่ยมชม)
      </button>
    </div>
  );
}
